import { Background, Logo, useChangeBackgroundStudioMutation, useChangeLogoStudioMutation, UserStudio } from '../../../../features/api/apiSlice';
import { getStreamOrientation } from '../../../../utils/streamOrientation';
import { BackgroundRenderer } from '../../BackgroundRenderer/BackgroundRenderer';
import { LogoRenderer } from '../LogoRenderer';
import styles from './ScenesElements.module.css';
import cn from 'classnames';

interface ScenesProps {
  background: Background[] | undefined;
  logos: Logo[] | undefined;
  studio?: UserStudio;
}

function Scenes({ background, logos, studio }: ScenesProps) {
  const [changeBackground] = useChangeBackgroundStudioMutation();
  const { isHorizontal } = getStreamOrientation(studio);
  const [changeLogo] = useChangeLogoStudioMutation();

  if (!background || !logos) {
    return <div className={styles.scenes}></div>;
  }

  const handleBackgroundChange = (selectedBackground: Background) => {
    if (studio?.current_scene) {
      changeBackground({
        id: selectedBackground.id,
        background: selectedBackground
      });
    }
  };

  const handleLogoChange = (selectedLogo: Logo) => {
    if (studio?.current_scene) {
      changeLogo({
        id: selectedLogo.id,
        logo: selectedLogo
      });
    }
  };

  const currentBackgroundId = studio?.current_scene?.background?.id;
  const currentLogoId = studio?.current_scene?.logo?.id;

  return (
    <div className={cn(
        styles.scenes,
        { [styles['scenes_portrait']]: !isHorizontal }
      )}
    >
      <h1 className={styles.scenes__title}>Фоны</h1>
      {background.length > 0 ? (
        <div>
          {background.map((background) => (
            <div
              key={background.id}
              className={cn(
                styles.scenes__item,
                { [styles.scenes__item_active]: currentBackgroundId === background.id }
              )}
              onClick={() => handleBackgroundChange(background)}
            >
              <BackgroundRenderer
                background={background}
                videoClassName={styles.scenes__image}
                imageClassName={styles.scenes__image}
              />
            </div>
          ))}
        </div>
      ) : (
        <p className={styles.scenes__message}>Нет доступных фонов</p>
      )}

      <h1 className={styles.scenes__title}>Логотипы</h1>
      {logos.length > 0 ? (
        <div className={styles.scenes__logo_container}>
          <div className={styles.scenes__logo}>
            {logos.map((logo) => (
              <div
                key={logo.id}
                className={cn(
                  styles.scenes__item,
                  { [styles.scenes__item_active]: currentLogoId === logo.id }
                )}
                onClick={() => handleLogoChange(logo)}
              >
                <div className={styles.scenes__item_container}>
                  <LogoRenderer
                    logo={logo}
                    imageClassName={styles.scenes__image}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      ) : (
        <p className={styles.scenes__message}>Нет доступных логотипов</p>
      )}
    </div>
  );
};

export default Scenes;